import type {RouteRecordRaw} from 'vue-router';
//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Permissions} from '@simpleforyou/coaching-shared';
import {Routes} from '@/common/enums/Routes';
//================= [VUE COMPONENTS] ==========================

export const courseRoutes: RouteRecordRaw[] = [
  {
    path: i18n.global.t('routes.course.courseList'),
    name: Routes.COURSE_LIST,
    component: () => import('@/components/course/CourseList.vue'),
    meta: {
      title: i18n.global.t('titles.course.courseList'),
      active: 'course',
      // T00MULLHA0HY — courses exist only with the booked COURSE module.
      coaching: 'course',
      roles: [Permissions.ROLE_COURSE_INDEX],
    },
  },
  {
    path: i18n.global.t('routes.course.courseEdit'),
    name: Routes.COURSE_EDIT,
    component: () => import('@/components/course/CourseEdit.vue'),
    meta: {
      title: i18n.global.t('titles.course.courseEdit'),
      active: 'course',
      coaching: 'course',
      roles: [Permissions.ROLE_COURSE_EDIT],
    },
  },
];
